import { useCallback } from 'react';
import Player from 'video.js/dist/types/player';

export interface UseMobilePlayControlsParams {
  playerRef: React.MutableRefObject<Player | null>;
  showMobilePlayButton: boolean;
  setShowMobilePlayButton: React.Dispatch<React.SetStateAction<boolean>>;
  showPauseOverlay: boolean;
  setShowPauseOverlay: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface UseMobilePlayControlsResult {
  handleMobilePlayTap: () => void;
}

/**
 * Hook to handle mobile play/pause tap interactions
 * Manages the play button visibility and pause overlay state
 */
export const useMobilePlayControls = ({
  playerRef,
  showMobilePlayButton,
  setShowMobilePlayButton,
  showPauseOverlay,
  setShowPauseOverlay,
}: UseMobilePlayControlsParams): UseMobilePlayControlsResult => {
  const handleMobilePlayTap = useCallback(() => {
    if (!showMobilePlayButton) {
      if (showPauseOverlay) {
        playerRef.current?.pause();
        setShowMobilePlayButton(true);
        setShowPauseOverlay(false);
      } else {
        setShowPauseOverlay(true);
        playerRef.current?.userActive(true);
        setTimeout(() => {
          setShowPauseOverlay(false);
          playerRef.current?.userActive(false);
        }, 1000);
      }
    } else {
      playerRef.current?.play();
      setShowMobilePlayButton(false);
    }
  }, [
    playerRef,
    showMobilePlayButton,
    setShowMobilePlayButton,
    showPauseOverlay,
    setShowPauseOverlay,
  ]);

  return { handleMobilePlayTap };
};
